// javascript to customize pages based on different user traits

function setThisCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getThisCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length,c.length);
    }
  }
  return "";
}


var existing_landing = getThisCookie("kgoal_landing");
if (existing_landing)  {
  //exists
  var existing_landing_url = new URL(existing_landing);  
  let existing_url_params = new URLSearchParams(existing_landing_url.search);
  var existing_params = Object.fromEntries(existing_url_params.entries());

  let new_url_params = new URLSearchParams(window.location.search);
  var new_params = Object.fromEntries(new_url_params.entries());

  var params_updated = false;
  for ( var property in new_params ) {
    if (!existing_params[property]) {
      existing_landing_url.href = existing_landing_url.href + '&' + property + '=' + new_params[property];
      params_updated = true;
    }
  }
  if (params_updated == true) {
    setThisCookie("kgoal_landing", existing_landing_url.href, 30);
  }
}
else {
  //does not yet exist
  const d = new Date();
  var time_string = d.toISOString();
  var new_ip = "";
  var first_symbol = "?";
  if (window.location.href.indexOf('?') != -1) {
    first_symbol = "&";
  }
  setThisCookie("kgoal_landing", window.location.href + first_symbol + 'arrival_time=' + time_string, 30);
  
  const ipController = new AbortController();
  const ipTimeoutId = setTimeout(() => ipController.abort(), 5000); // Timeout after 5 seconds

  fetch('https://api.ipify.org?format=json', { signal: ipController.signal })
  .then(response => {
    clearTimeout(ipTimeoutId); // Clear timeout if request succeeds
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(data => {
    new_ip = data.ip;
    //console.log("ip: " + new_ip);
    setThisCookie("kgoal_landing", window.location.href + first_symbol + 'ip=' + new_ip + '&arrival_time=' + time_string, 30);
  })
  .catch(error => {
    if (error.name === 'AbortError') {
      console.error('Fetch request timed out');
    } else {
      console.error('Error fetching data:', error);
    }
  });

  
/* old: using jquery.

  //does not yet exist
  const d = new Date();
  var time_string = d.toISOString();
  var new_ip = "";
  $(document).ready(()=>{
      $.getJSON("https://api.ipify.org?format=json",
      function (data) {  
          new_ip = data.ip;
          //console.log("ip: " + new_ip);
          var first_symbol = "?";
          if (window.location.href.indexOf('?') != -1) {
            first_symbol = "&";
          }
          setThisCookie("kgoal_landing", window.location.href + first_symbol + 'ip=' + new_ip + '&arrival_time=' + time_string, 30);        
      })
  });
  
*/
  
}

/*
if (window.location.href.indexOf('app_welcome') != -1) {
    //app referral
    //check if existing app referral
    let existing_app_welcome = getThisCookie("app_welcome");
    if (existing_app_welcome)  {
      //exists
      //console.log('existing app welcome: ' + existing_app_welcome);
    }
    else {
      //does not yet exist
      const d = new Date();
      let time_string = d.toISOString();
      setThisCookie("app_welcome", window.location + '&arrival_time=' + time_string, 30);        
    }
}
*/

var customized_already = false;
var pnp = document.getElementById("productNormalPrice");
var psp = document.getElementById("productSpecialPrice");

function customizeDiscount(discountCode, discountPercentage, discountDollars)  {  
  if (customized_already) {
    return;
  }
    
  if ((discountPercentage > 0) || (discountDollars > 0)) {
  	var el = document.getElementById("discountDiv");
    if(el) {
      document.getElementById("discountDiv").innerHTML = "<input type=\"hidden\" name=\"discount\" value=\"" + discountCode + "\">"; 	
    }
    
    var el = document.getElementById("productNormalPrice");
    if (el) {
      document.getElementById("productNormalPrice").style.textDecoration = "line-through";
    }
    
    var el = document.getElementById("cartTotalPrice");
    if (el) {
      document.getElementById("cartTotalPrice").innerHTML = document.getElementById("cartTotalPrice").innerHTML + " Today";
      //document.getElementById("cartTotalPrice").style.textDecoration = "line-through";
      //document.getElementById("cartTotalPrice").style.color = "#4d4d4d";
    }
    
    var el = document.getElementById("cartNewTotalPrice");
    if (el) {
  		//document.getElementById("cartNewTotalPrice").style.display = "inline";
    }
  }
  
  if (discountPercentage > 0) {
    var newPriceFraction = 1 - (discountPercentage / 100);
    
    var el = document.getElementById("headerBanner");
    if (el) {
      document.getElementById("headerBanner").innerHTML = "<b>" + discountPercentage + "% OFF Today!<\/b>";
    }
    
    var el = document.getElementById("cartNewTotalPrice");
    if (el) {
      //document.getElementById("cart_headline").innerHTML = "Special pricing today!";
      //document.getElementById("cartNewTotalPrice").innerHTML = '<span rv-show="cart.discountApplied"><b>{ cart.total_price | money Currency.currentCurrency } Today<\/b><br><\/span><span rv-show="!cart.discountApplied"><b>{ cart.total_price | times " + newPriceFraction + " | money Currency.currentCurrency } Today<\/b><br><\/span>';
    }

    var els = document.getElementsByClassName("cart-item-final-price");
    for (var i=0;i<els.length;i++) {
      //els[i].innerHTML = "{ item.price | times " + newPriceFraction + " | money Currency.currentCurrency }";
    }

    //document.getElementById("thisItemPriceLabel").innerHTML = "Regular Price: ";       
    //document.getElementById("thisItemPriceLabel").style.display = "inline";
    //document.getElementById("thisItemPrice").style.textDecoration = "line-through";

    var el = document.getElementById("productSpecialPrice");
    if (el) {
      document.getElementById("productSpecialPrice").innerHTML = document.getElementById("productSpecialPrice").innerHTML + " <b>+ " + discountPercentage + "% OFF Today!<\/b>";
    }
             
    
  } else if (discountDollars > 0) {
    var discountCents = 100 * discountDollars;
    
    var el = document.getElementById("headerBanner");
    if (el) {
      document.getElementById("headerBanner").innerHTML = "<b>$" + discountDollars + " OFF Today!<\/b>";
    }
    
    var el = document.getElementById("cartNewTotalPrice");
    if (el) {
      //document.getElementById("cart_headline").innerHTML = "Special pricing today!";
      document.getElementById("cartNewTotalPrice").innerHTML = "<b>{ cart.total_price | minus " + discountCents + " | money Currency.currentCurrency }</b><br>";

      //document.getElementById("thisItemPriceLabel").innerHTML = "Regular Price: ";       
      //document.getElementById("thisItemPriceLabel").style.display = "inline";

      //document.getElementById("thisItemPrice").innerHTML = "{ item.price | minus " + discountCents + " | money Currency.currentCurrency }";
      //document.getElementById("thisItemPrice").style.textDecoration = "line-through";
    }
    var el = document.getElementById("productSpecialPrice");
    if (el) {
      document.getElementById("productSpecialPrice").innerHTML = " <b>$" + discountDollars + " off today!<\/b>";
    }
                    	
  }
  
  //don't show promo in cart
  if(document.getElementById("cartPromoClick")) {
   document.getElementById("cartPromoClick").style.display = "none";
   //document.getElementById("cartPromoClick").innerHTML = "Your special " + discountCode + " discount is applied below:";
   document.getElementById("cartPromoClick").innerHTML = "Use code <b>" + discountCode + "<\/b> in checkout for an extra " + discountPercentage + "% off today!";
  }

  customized_already = true;
  
}


function BFcustomizeDiscount()  { 
  //2020 BF discount customization;
    
  //automatic discount is applied, so need to insert code manually.
  //document.getElementById("discountDiv").innerHTML = "<input type=\"hidden\" name=\"discount\" value=\"" + discountCode + "\">"; 	
  
  
  //document.getElementById("cartTotalPrice").style.textDecoration = "line-through";
  //document.getElementById("cartNewTotalPrice").style.display = "inline";
  
  //update product page pricing and messaging.
  
  
  if (window.location.href.indexOf('kgoal-smart-kegel-exerciser') != -1)  {
    document.getElementById("headerBanner").innerHTML = "<b>33% OFF Today!<\/b>";
    if (pnp) {
      document.getElementById("productNormalPrice").style.textDecoration = "line-through";
    }
    if (psp) {
      document.getElementById("productSpecialPrice").innerHTML = " <b>$134 Today<\/b>";
    }
  }
  else if (window.location.href.indexOf('kgoal-boost-kegel-trainer') != -1) {
    document.getElementById("headerBanner").innerHTML = "<b>33% OFF Today!<\/b>";
    if (pnp) {
      document.getElementById("productNormalPrice").style.textDecoration = "line-through";
    }
    if (psp) {
      document.getElementById("productSpecialPrice").innerHTML = " <b>$134 Today<\/b>";
    }
  }
  else if (window.location.href.indexOf('kgoal-intimflex-kegel-trainer-for-women') != -1) {
    document.getElementById("headerBanner").innerHTML = "<b>33% OFF Today!<\/b>";
    if (pnp) {
      document.getElementById("productNormalPrice").style.textDecoration = "line-through";
    }
    if (psp) {
      document.getElementById("productSpecialPrice").innerHTML = " <b>$147 Today<\/b>";
    }
  }
  else {
    document.getElementById("headerBanner").innerHTML = "<b>33% OFF Today!<\/b>"; 
  }
  
  //update cart pricing and messaging.
  var newPriceFraction = 0.67;
  //document.getElementById("shipsToday").innerHTML = "<b>Special kGoal pricing<br>ends today...<\/b>";
  //document.getElementById("thisItemPrice").innerHTML = "<span style='color:#009cdb;'><b>{ item.price | times " + newPriceFraction + " | money Currency.currentCurrency }<\/b><\/span>";
  
  //document.getElementById("cart_headline").innerHTML = "<h1>Your Cart<\/h1><h3 style='color:#009cdb;'>Special Pricing Today!<\/h3>";
  //document.getElementById("cartTotalPrice").innerHTML = "<span style='color:#009cdb;'><b>{ cart.total_price | times " + newPriceFraction + " | money Currency.currentCurrency }<\/b><\/span>";
 
  //document.getElementById("thisItemPriceLabel").innerHTML = "Regular Price: ";       
  //document.getElementById("thisItemPriceLabel").style.display = "inline";
  //document.getElementById("thisItemPrice").style.textDecoration = "line-through";
 
  if(document.getElementById("cartPromoClick")) {
    document.getElementById("cartPromoClick").style.display = "none";
    //document.getElementById("cartPromoClick").innerHTML = "Your special " + discountCode + " discount is applied below:";
    document.getElementById("cartPromoClick").innerHTML = "Today's <b>33% Discount</b> is automatically applied to your order.";
  }

  customized_already = true;
}


function StrikethroughDiscount()  { 
  //strikethrough pricing discount customization;
    
  //automatic discount is applied, so need to insert code manually.
  //document.getElementById("discountDiv").innerHTML = "<input type=\"hidden\" name=\"discount\" value=\"" + discountCode + "\">"; 	
  
  
  //document.getElementById("cartTotalPrice").style.textDecoration = "line-through";
  //document.getElementById("cartNewTotalPrice").style.display = "inline";
  
  //update product page pricing and messaging.
  
  if ((window.location.href.indexOf('charger') == -1) && (window.location.href.indexOf('lubricant') == -1) && (window.location.href.indexOf('tissues') == -1) && (window.location.href.indexOf('accessories') == -1) && (window.location.href.indexOf('help') == -1)) {
  //if ((window.location.href.indexOf('kgoal-smart-kegel-exerciser') != -1) || (window.location.href.indexOf('kgoal-boost-kegel-trainer') != -1))  {
    if (window.location.href.indexOf('header_test') != -1) {

    }
    else if (window.location.href.indexOf('kgoal-intimflex-kegel-trainer-for-women') != -1) {
      //IntimFlex page
      document.getElementById("headerBanner").innerHTML = "<b>$20 OFF Today<\/b>";
      
      var el = document.getElementById("productNormalPrice");
      if (el) {
        document.getElementById("productNormalPrice").style.textDecoration = "line-through";
        document.getElementById("productNormalPrice").innerHTML = "$219";
        document.getElementById("productSpecialPrice").innerHTML = " <b>$199<\/b>";
      }
    }
    else {    
      document.getElementById("headerBanner").innerHTML = "<b>$20 OFF Today<\/b>";

      var el = document.getElementById("productNormalPrice");
      if (el) {
        document.getElementById("productNormalPrice").style.textDecoration = "line-through";
        document.getElementById("productNormalPrice").innerHTML = "$199";
        document.getElementById("productSpecialPrice").innerHTML = " <b>$179<\/b>";
      }
    }
  }
  else {
    //document.getElementById("headerBanner").innerHTML = "<b>25% OFF Today!<\/b>"; 
  }
  
  //update cart pricing and messaging.
  //var newPriceFraction = 0.75;
  //document.getElementById("shipsToday").innerHTML = "<b>Special kGoal pricing<br>ends today...<\/b>";
  //document.getElementById("thisItemPrice").innerHTML = "<span style='color:#009cdb;'><b>{ item.price | times " + newPriceFraction + " | money Currency.currentCurrency }<\/b><\/span>";
  
  //document.getElementById("cart_headline").innerHTML = "<h1>Your Cart<\/h1><h3 style='color:#009cdb;'>Special Pricing Today!<\/h3>";
  //document.getElementById("cartTotalPrice").innerHTML = "<span style='color:#009cdb;'><b>{ cart.total_price | times " + newPriceFraction + " | money Currency.currentCurrency }<\/b><\/span>";
 
  //document.getElementById("thisItemPriceLabel").innerHTML = "Regular Price: ";       
  //document.getElementById("thisItemPriceLabel").style.display = "inline";
  //document.getElementById("thisItemPrice").style.textDecoration = "line-through";
 
}

StrikethroughDiscount();

//BFcustomizeDiscount();

/*
if (window.location.href.indexOf('BFtest') != -1) {
  BFcustomizeDiscount();
}
else {
  StrikethroughDiscount();
}
  */

//test ga param
/*
if (window.location.href.indexOf('ga_test') != -1) {
  var ga_value = getThisCookie("_ga");
  if (ga_value != "") {
    const gaArray = ga_value.split(".");
    if (gaArray[2] && gaArray[3]) {
      const ga_parsed = gaArray[2].concat(".",gaArray[3]);
      if (document.getElementById("ga_div")) {
        document.getElementById("ga_div").innerHTML = ga_parsed;
      }
    }
  }
}
*/

function cartMutationObserver()  {

    var $div = $("#cart");
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === "class") {
          var attributeValue = $(mutation.target).prop(mutation.attributeName);
          //console.log("Class attribute changed to:", attributeValue);

          var klElements = document.querySelectorAll('[class^="kl-teaser"],[class*=" kl-teaser"]');
          
          //var klElements = document.getElementByClassName("kl-teaser-VgSvj9");
          
          for (var i=0; i<klElements.length; i++) {
            this_element = klElements[i];
            if (attributeValue == 'cart cart--visible') {
              //hide kl campaign
              this_element.style.display = "none";
            
            }
            else {
              this_element.style.display = "block";
            }
          }

          if (attributeValue == 'cart cart--visible') {
            setTimeout(function() {
              var cartItems = document.getElementsByClassName("cart-item-id");
              var cartItemPriceLabels = document.getElementsByClassName("cart-item-price-label");
              var cartItemPrices = document.getElementsByClassName("cart-item-price");
              var cartItemFinalPriceLabels = document.getElementsByClassName("cart-item-final-price-label");
              var cartItemFinalPrices = document.getElementsByClassName("cart-item-final-price");

              var promoClickDisplay = "block";
              var autoDiscountDisplay = "none";
              
              var boost_out_of_stock = false;
              var classic_out_of_stock = false;
              
              for (let i=0; i<cartItems.length; i++) {
                this_element = cartItems[i];
                var product_id = this_element.innerHTML;
                if ((product_id == 4118385799) && (boost_out_of_stock == true)) {
                  if (document.getElementById("cartPromoClick")) {
                    //boost-men
                    
                    promoClickDisplay = "none";
                    autoDiscountDisplay =  "block";
                    
                    document.getElementById("discountDiv").innerHTML = "<input type=\"hidden\" name=\"discount\" value=\"" + "BUYNOW25" + "\">";
                    
                  }
                  if (cartItemFinalPrices[i]) {
                    //cartItemPrices[i].style.textDecoration = "line-through";
                    //cartItemFinalPrices[i].style.display = "inline";
                    //cartItemFinalPrices[i].style.color = "#009cdb";
                  }
                }
                if ((product_id == 7500878643349) && (boost_out_of_stock == true)) {
                  if (document.getElementById("cartPromoClick")) {
                    //boost-women

                    promoClickDisplay = "none";
                    autoDiscountDisplay = "block";
                    
                    document.getElementById("discountDiv").innerHTML = "<input type=\"hidden\" name=\"discount\" value=\"" + "BUYNOW25" + "\">";
                  }
                }
                if ((product_id == 352094977) && (classic_out_of_stock == true)) {
                  if (document.getElementById("cartPromoClick")) {
                    //kgoal-classic

                    promoClickDisplay = "none";
                    autoDiscountDisplay = "block";
                    
                    document.getElementById("discountDiv").innerHTML = "<input type=\"hidden\" name=\"discount\" value=\"" + "BUYNOW25" + "\">";
                  }
                }
              }
  
                if (document.getElementById("cartPromoClick")) {
                  document.getElementById("cartPromoClick").style.display = promoClickDisplay;
                }
                if (document.getElementById("cartAutoDiscountMsg")) {
                  document.getElementById("cartAutoDiscountMsg").style.display = autoDiscountDisplay;
                }
            },500);
          }
          else {
            if (document.getElementById("cartPromoClick")) {
                document.getElementById("cartPromoClick").style.display = "none";
            }
            if (document.getElementById("cartAutoDiscountMsg")) {
                document.getElementById("cartAutoDiscountMsg").style.display = "none";
            }
          }
  
        }
      });
    });
    observer.observe($div[0], {
      attributes: true
    });
}

cartMutationObserver();


function cartPromoDiscount()  {
  if(document.getElementById("cartPromoClick")) {
    document.getElementById("cartPromoClick").innerHTML = "<span style=\"color:#009cdb;\">Sign up for <a href=\"#\" class=\"blue-underline\">10% off<\/a><br>today's order<\/span>";
    
    var $div = $("#cart");
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === "class") {
          var attributeValue = $(mutation.target).prop(mutation.attributeName);
          //console.log("Class attribute changed to:", attributeValue);
          
          var klElements = document.getElementByClassName("kl-teaser-VgSvj9");
          
          if (klElements[0]) {
            this_element = klElements[0];
            if (attributeValue == 'cart cart--visible') {
              //hide OM campaign 44 
              this_element.style.display = "none";
            
            }
            else {
              this_element.style.display = "block";
            }
          }
          
        }
      });
    });
    observer.observe($div[0], {
      attributes: true
    });
    
  }
}

/*
setTimeout(function(){
  var omCampaign = document.getElementById("om-campaign-62");
  if (omCampaign)  {
    cartPromoDiscount();
  }
  else {
    setTimeout(function(){
      var omCampaign2 = document.getElementById("om-campaign-62");
      if (omCampaign2)  {
        cartPromoDiscount();
      }
      else {
        setTimeout(function(){
      	  var omCampaign3 = document.getElementById("om-campaign-62");
      	  if (omCampaign3)  {
        	cartPromoDiscount();
          }
        },5000);        
      }
    },5000);
  }
},5000);
*/

var el = document.getElementsByClassName("KlCartPromoClick");
if (el[0]) {
  document.querySelector('.KlCartPromoClick').addEventListener('click', function (){
      window._klOnsite = window._klOnsite || []; 
      window._klOnsite.push(['openForm', 'TsLixB']);    //was TsLixB;  //new form Xy7tBh;
      gtag('event','kl_cart_promo_click', {'form_id':'TsLixB'});      //was TsLixB;
  });
}


if (window.location.href.indexOf('lang=ru') != -1) {
  
    if (document.getElementById("android-location-permission-gif").src) {
      document.getElementById("android-location-permission-gif").src = "https://cdn.shopify.com/s/files/1/0062/0362/files/kGoal_-_location_permission_settings_-_Russian_-_2020_11_17.gif?v=1605674646";
    }
  
}


const sameDayShippingMessageActive = false;
if (sameDayShippingMessageActive)  {
//same day shipping notification in Cart
  // Update the count down every 1 second
  var updateTextInterval = setInterval(function() {

    // Get today's date and time adjusted to GMT
    var now = new Date();
    var gmt = new Date(now.getTime() + now.getTimezoneOffset() * 60000);


    var gmtDay = gmt.getDay();
    var gmtHours = gmt.getHours();
    var gmtMinutes = gmt.getMinutes();
    var gmtSeconds = gmt.getSeconds();

    //between 7am and 11am PT  (14:00 and 18:00 GMT)
    var gmtEarlyCutoff = 15;
    var gmtLateCutoff = 19;

    if ((gmtDay > 0) && (gmtDay < 6))  {
        //weekday
        if ((gmtHours >= gmtEarlyCutoff) && (gmtHours < gmtLateCutoff))  {

            // Find the distance between now and the count down date
            var distanceHours = gmtLateCutoff - gmtHours - 1;
            var distanceMinutes = 60 - gmtMinutes;
            var distanceSeconds = 60 - gmtSeconds;
          
          if (distanceHours == 1)  {
            var hoursStr = "hr ";
          }
          else {
            var hoursStr = "hrs ";
          }
          
          if (distanceMinutes == 1)  {
            var minutesStr = "min ";
          }
          else {
            var minutesStr = "min ";
          }
          
          if (distanceSeconds == 1)  {
            var secondsStr = "sec ";
          }
          else {
            var secondsStr = "sec ";
          }

            // Time calculations for days, hours, minutes and seconds
            //var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            //var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            //var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            //var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            // Output the result in an element with id="demo"
            //document.getElementById("demo").innerHTML = days + "d " + hours + "h "  + minutes + "m " + seconds + "s ";
            var updateStr = "";

            if (distanceHours == 0)  {
              if (distanceMinutes >= 3)  {
                updateStr = "Orders made in the next<br><b>" + distanceMinutes + minutesStr + "</b>will ship today.";
              }
            }
            else if (distanceMinutes >= 2) {
              updateStr = "Orders made in the next<br><b>" + distanceHours + hoursStr + distanceMinutes + minutesStr + "</b>will ship today.";
            }
            else {
              updateStr = "Orders made in the next<br><b>" + distanceHours + hoursStr + distanceMinutes + minutesStr + "</b>will ship today.";
            }

            document.getElementById("shipsToday").innerHTML = updateStr;


        }
    }
    else {
      document.getElementById("shipsToday").innerHTML = "";
    }

  }, 1000);  
  
  
}



/*

if (window.location.href.indexOf('testing=') != -1) {
	document.getElementById("headerBanner").innerHTML = "<b>25% off today!<\/b>";
	document.getElementById("productNormalPrice").style.textDecoration = "line-through";
    
    if (window.location.href.indexOf('\/products\/ola') != -1) {
        document.getElementById("productSpecialPrice").innerHTML = " <b>$50 off Ola today!<\/b>";
    } else {
    	document.getElementById("productSpecialPrice").innerHTML = " <b>25% off today!<\/b>";
    }
  
  	document.getElementById("thisItemPrice").style.textDecoration = "line-through";
    document.getElementById("thisItemPriceLabel").innerHTML = "Regular Price: ";
    document.getElementById("thisItemPriceLabel").style.display = "inline";
    
}

*/



// customize page based on specific referral source
var referrerParams = [
  { referrerName: 		"test-referrer-name",
    discountCode:     	"test-discount-code",
    discountPercentage:	0,
    discountDollars:	0
  }
];


/*  parking lot for additional referral discounts
  ,
  { referrerName: 		"buzzfeed",
    discountCode:     	"15PercentSurprise",
    discountPercentage:	15,
    discountDollars:	0
  },
  { referrerName: 		"womenshealth",
    discountCode:     	"15PercentSurprise",
    discountPercentage:	15,
    discountDollars:	0
  },
  { referrerName: 		"bustle",
    discountCode:     	"15PercentSurprise",
    discountPercentage:	15,
    discountDollars:	0
  },
  { referrerName: 		"shape",
    discountCode:     	"15PercentSurprise",
    discountPercentage:	15,
    discountDollars:	0
  },
  { referrerName: 		"elle",
    discountCode:     	"15PercentSurprise",
    discountPercentage:	15,
    discountDollars:	0
  },
  { referrerName: 		"glamour",
    discountCode:     	"15PercentSurprise",
    discountPercentage:	15,
    discountDollars:	0
  },
  { referrerName: 		"cosmopolitan",
    discountCode:     	"15PercentSurprise",
    discountPercentage:	15,
    discountDollars:	0
  },
  { referrerName: 		"heyepiphora",
    discountCode:     	"15PercentSurprise",
    discountPercentage:	15,
    discountDollars:	0
  },
  { referrerName: 		"lifehacker",
    discountCode:     	"15PercentSurprise",
    discountPercentage:	15,
    discountDollars:	0
  },
  { referrerName: 		"ampproject",
    discountCode:     	"15PercentSurprise",
    discountPercentage:	15,
    discountDollars:	0
  },
  { referrerName: 		"mensfitness",
    discountCode:     	"15PercentSurprise",
    discountPercentage:	15,
    discountDollars:	0
  },
  { referrerName: 		"salon",
    discountCode:     	"15PercentSurprise",
    discountPercentage:	15,
    discountDollars:	0
  }
];

*/

var referrerLength = referrerParams.length;
for (i=0 ; i < referrerLength ; i++)  {
  
  if (document.referrer.indexOf(referrerParams[i].referrerName) != -1) {
      setThisCookie("referrer", referrerParams[i].referrerName, 30);
      customizeDiscount(referrerParams[i].discountCode, referrerParams[i].discountPercentage, referrerParams[i].discountDollars);
  } else if (getThisCookie("referrer") == referrerParams[i].referrerName)  {
      customizeDiscount(referrerParams[i].discountCode, referrerParams[i].discountPercentage, referrerParams[i].discountDollars);
  }
}


if (document.referrer.indexOf('instagram.com') != -1) {
    //console.log(document.referrer);
    //setThisCookie("referrer", 'instagram', 30);
    //customizeDiscount('LIBDO-KGOAL', 20, 0);
} else if (getThisCookie("referrer") == 'instagram')  {
    //customizeDiscount('LIBDO-KGOAL', 20, 0);
}

if (window.location.href.indexOf('8138525.b1cf99') != -1) {
    setThisCookie("referrer", 'libdo', 30);
    customizeDiscount('LIBDO-KGOAL', 20, 0);
} else if (getThisCookie("referrer") == 'libdo')  {
    customizeDiscount('LIBDO-KGOAL', 20, 0);
}


if (window.location.href.indexOf('2644885.974547') != -1) {
      setThisCookie("milana", "Y", 30);
      customizeDiscount("MILANA", 0, 25);
} else if (getThisCookie("milana") == "Y")  {
      customizeDiscount("MILANA", 0, 25);
}


if (window.location.href.indexOf('2297631.d87c2') != -1)  {
   setThisCookie("functionalpelvis", "Y", 30);
   customizeDiscount("FUNCTIONALPELVIS", 20, 0);
}  else if (getThisCookie("functionalpelvis") == "Y")  {
   customizeDiscount("FUNCTIONALPELVIS", 20, 0);
}
  
  
var el = document.getElementById("discountDiv");
if (el) {
  if (window.location.href.indexOf('6463647.bb4351') != -1)  {
     setThisCookie("drmalik", "Y", 30);
     document.getElementById("discountDiv").innerHTML = "<input type=\"hidden\" name=\"discount\" value=\"" + "DR-MALIK" + "\">";
  }  else if (getThisCookie("drmalik") == "Y")  {
     document.getElementById("discountDiv").innerHTML = "<input type=\"hidden\" name=\"discount\" value=\"" + "DR-MALIK" + "\">";
  }

  if (window.location.href.indexOf('6931026.353839') != -1)  {
     setThisCookie("coredynamics", "Y", 30);
     document.getElementById("discountDiv").innerHTML = "<input type=\"hidden\" name=\"discount\" value=\"" + "COREDYNAMICS" + "\">";
  }  else if (getThisCookie("coredynamics") == "Y")  {
     document.getElementById("discountDiv").innerHTML = "<input type=\"hidden\" name=\"discount\" value=\"" + "COREDYNAMICS" + "\">";
  }

  if (window.location.href.indexOf('6981085.56229f') != -1)  {
     setThisCookie("baseem", "Y", 30);
     document.getElementById("discountDiv").innerHTML = "<input type=\"hidden\" name=\"discount\" value=\"" + "BASEEM" + "\">";
  }  else if (getThisCookie("baseem") == "Y")  {
     document.getElementById("discountDiv").innerHTML = "<input type=\"hidden\" name=\"discount\" value=\"" + "BASEEM" + "\">";
  }  
  

  if (window.location.href.indexOf('discount=GetBoost') != -1)  {
     setThisCookie("GetBoost", "Y", 5);
     document.getElementById("discountDiv").innerHTML = "<input type=\"hidden\" name=\"discount\" value=\"" + "GetBoost" + "\">";
  }  else if (getThisCookie("GetBoost") == "Y")  {
     document.getElementById("discountDiv").innerHTML = "<input type=\"hidden\" name=\"discount\" value=\"" + "GetBoost" + "\">";
  }

}

var this_el = document.getElementById("out_of_stock_message_container");
if (this_el && el) {
  document.getElementById("discountDiv").innerHTML = "<input type=\"hidden\" name=\"discount\" value=\"" + "BUYNOW25" + "\">";
  var this_floating_cart = document.getElementById("product-add-btn-floating");
  if (this_floating_cart) {
    this_floating_cart.value = "Buy Now (25% OFF)";
  }
}


// look for pepperjam referral content in incoming URL and set cookie
// if Pepperjam visitor, then populate appropriate discount content
/*
if (window.location.href.indexOf('pepperjam') != -1) {
  //set Pepperjam cookie
  setThisCookie("pepperjam", "Y", 1);
  if (window.location.href.indexOf('products\/ola') != -1)  {
  	 //do nothing for ola page
  }  else  {
    customizeDiscount("HEALTHYSAVINGS", 25, 0);
  }
} else {
  if (getThisCookie("pepperjam") != "")  {
    //pepperjam cookie exists 
    if (window.location.href.indexOf('products\/ola') != -1)  {
  	   //do nothing for ola page
    }  else  {
    	customizeDiscount("HEALTHYSAVINGS", 25, 0);
  	}
  } else {
    //not pepperjam

  }
}

*/


// look for AdWords content in incoming URL and set cookie
// if AdWords visitor, then populate appropriate discount content
/*
if (window.location.href.indexOf('gclid=') != -1) {
  //set ADW cookie
  setThisCookie("ADW", "Y", 1);
  customizeDiscount("20PercentSpecial", 20, 0);
} else {
  if (getThisCookie("ADW") != "")  {
    //ADW exists 
    customizeDiscount("20PercentSpecial", 20, 0);
  } else {
    //no ADW

  }
}
*/


// End AdWords section

/*
// Ola discount customization section
if (window.location.href.indexOf('mc_cid=') != -1)  {
  setThisCookie("MailChimp", "Y", 10);
  if (window.location.href.indexOf('\/products\/ola') != -1) {
    document.getElementById("productNormalPrice").style.textDecoration = "line-through";   
    document.getElementById("productSpecialPrice").innerHTML = " <b>$50 off Ola today!<\/b>";
    document.getElementById("headerBanner").innerHTML = "";
  }
    
  //document.getElementById("discountDiv").innerHTML = "<input type=\"hidden\" name=\"discount\" value=\"BIGDEAL2017\">";

}
else {
  if (getThisCookie("MailChimp") != "") {
    if (window.location.href.indexOf('\/products\/ola') != -1) {
      document.getElementById("productNormalPrice").style.textDecoration = "line-through";   
      document.getElementById("productSpecialPrice").innerHTML = " <b>$50 off Ola today!<\/b>";
      document.getElementById("headerBanner").innerHTML = "";
    }
    
    //document.getElementById("discountDiv").innerHTML = "<input type=\"hidden\" name=\"discount\" value=\"BIGDEAL2017\">";
  	
  }
}

*/





// testing stuff below:

/* 
if (window.location.href.indexOf('testing=') != -1) {
	document.getElementById("headerBanner").innerHTML = "<b>25% off today!<\/b>";
	document.getElementById("productNormalPrice").style.textDecoration = "line-through";
    
    if (window.location.href.indexOf('\/products\/ola') != -1) {
        document.getElementById("productSpecialPrice").innerHTML = " <b>$50 off Ola today!<\/b>";
    } else {
    	document.getElementById("productSpecialPrice").innerHTML = " <b>25% off today!<\/b>";
    }
  
  	document.getElementById("thisItemPrice").style.textDecoration = "line-through";
    document.getElementById("thisItemPriceLabel").innerHTML = "Regular Price: ";
    document.getElementById("thisItemPriceLabel").style.display = "inline";
    
}

*/


//document.getElementById("headerTest").innerHTML = "+";

//document.getElementById("testContent").innerHTML = referrerParams[0].discountDollars;

// setThisCookie("test","testing",0.00694);

/*
if (document.referrer.indexOf("cosmopolitan") != -1) {
      setThisCookie("referrer", "cosmopolitan", 1);
      customizeDiscount("10BucksOff", 0, 10);
} else if (getThisCookie("referrer") == "cosmopolitan")  {
      customizeDiscount("10BucksOff", 0, 10);
}
*/

// document.getElementById("testContent").innerHTML = "{ cart.item_count | times 2 }";

